import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectPackageGoldCost } from "../../../balancingSelectors/selectBalancingPackages";
import { IdResource } from "../../../constants/IdResource";
import { selectPlayerInfo } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionInventoryInfoRemoveResource } from "../../info/inventory/actionInventoryInfo";
import { actionPurchasePackageInfoPurchased } from "../../info/purchase-packages/actionSetPurchasePackageInfo";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionConsumePackage, TypeActionPackages, } from "../actionPackages";
export var epicPackageExpenseConfirmed = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionPackages.RequestPackageExpenseConfirmed), switchMap(function (action) {
        var state = state$.value;
        var playerId = selectPlayerInfo(state).playerId;
        var packageId = action.packageId;
        return deps
            .netSend({
            id: CommandCode.BuyPackage,
            props: {
                amount: 1,
                packageId: packageId,
                playerId: playerId,
            },
        })
            .pipe(retry(), switchMap(function (res) {
            var cost = selectPackageGoldCost(packageId);
            var goldCost = { amount: cost, typeId: IdResource.Gold };
            return from([
                actionConsumePackage(packageId),
                actionInventoryInfoRemoveResource([goldCost]),
                actionPurchasePackageInfoPurchased(packageId),
                actionModalClose(IdModal.LeagueReward),
            ]);
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/item-packages/epics/epicPackageExpenseConfirmed.ts
// module id = 1978
// module chunks = 3